import * as React from 'react';
import { PropsWithChildren } from 'react';
import styles from '../styles.module.scss';
import { DataTableHeaderProps } from './types';

export const DataTableHeader: React.FC<DataTableHeaderProps> = ({
  children
}: PropsWithChildren<DataTableHeaderProps>) => (
  <thead className={styles.thead}>
    <tr>{children}</tr>
  </thead>
);
